import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { RfqImage } from '../fields/rfq-image';
import { RfqEmailRecognizedIllustration } from '../images/rfq-email-recognized-illustration';

export const RfqFlyoutStepRecognizedEmail = () => {
   const translate = useTranslations();

   return (
      <Box direction="column">
         <RfqImage>
            <RfqEmailRecognizedIllustration />
         </RfqImage>
         <Typography component="h4" variant="heading-4" color="primary">
            {translate('page-consumer.request-for-quotation.email-recognized-title')}
         </Typography>
         <Typography component="span" variant="body" color="strong">
            {translate('page-consumer.request-for-quotation.email-recognized-description')}
         </Typography>
      </Box>
   );
};
